import { SERVER_URL } from "../utils/constants";

const setNewUserPassword = async (user, password, newPassword) => {

    const response = await fetch(`${SERVER_URL}/setNewUserPassword`, {
        method: "post",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: user.username, password, newPassword }),
    });
    if (response.status !== 200) {
        throw new Error("Nie zmieniono hasła");
    }
    return await response.json();
};

export default setNewUserPassword;
